<template>
  <div class="row">
    <div
      class="col-12 d-flex justify-content-start justify-content-md-end mt-3"
      :class="isMobile && 'w-100'"
    >
      <div class="dropdown" :class="isMobile && 'w-100'">
        <button
          class="btn dropdown-toggle bg-light text-dark border-color--gray-3 font-weight-normal px-3 py-0"
          :class="isMobile ? 'rounded w-100' : 'rounded-pill'"
          type="button"
          data-toggle="dropdown"
          aria-expanded="false"
          ref="btnSort"
        >
          {{ placeholder }}
        </button>
        <div class="dropdown-menu ml-5 ml-md-0" ref="dropdownMenu">
          <a
            class="dropdown-item cursor-pointer mb-2"
            @click="sort(getAZ, 'Nombre (A-Z)')"
          >
            <i class="fa-solid fa-arrow-down-a-z text-green mr-2"></i>
            Nombre (A-Z)
          </a>
          <a
            class="dropdown-item cursor-pointer mb-2"
            @click="sort(getGenerateDate)"
          >
            <i class="fas fa-file-export text-green mr-2"></i>
            Fecha de generación
          </a>
          <a
            class="dropdown-item cursor-pointer mb-2"
            @click="sort(getModifiedDate)"
          >
            <i class="fas fa-edit text-green mr-2"></i>
            Fecha de modificación
          </a>
          <a
            v-if="!hiddenShared"
            class="dropdown-item cursor-pointer mb-2"
            @click="sort(getShared)"
          >
            <i class="fas fa-link font-weight-normal text-green mr-2"></i>
            Compartidos por mi
          </a>
          <a
            v-if="showSharedDate"
            class="dropdown-item cursor-pointer mb-2"
            @click="sort(getSharedDate)"
          >
            <i class="fas fa-link text-green mr-2"></i>
            Fecha de compartido
          </a>
          <a
            v-if="showInactive"
            class="dropdown-item cursor-pointer mb-2"
            @click="sort(getInactive)"
          >
            <i class="fas fa-ban text-green mr-2"></i>
            Fecha de inactivación
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rbSorterBy from '@/utils/constants/rbSorterBy.js'
export default {
  name: 'SortBy',
  props: {
    selected: {
      type: Number,
      default: null,
    },
    hiddenShared: {
      type: Boolean,
      default: false,
    },
    showSharedDate: {
      type: Boolean,
      default: false,
    },
    showInactive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    placeholder() {
      const opt = {
        0: 'Ordenar por',
        1: 'Nombre (A-Z)',
        2: 'Fecha de generación',
        3: 'Fecha de modificación',
        4: 'Compartidos por mi',
        5: 'Fecha de compartido',
        6: 'Fecha de inactivación',
      }

      return opt[this.selected]
    },
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    getAZ() {
      return rbSorterBy.AZ
    },
    getGenerateDate() {
      return rbSorterBy.GenerateDate
    },
    getModifiedDate() {
      return rbSorterBy.ModifiedDate
    },
    getShared() {
      return rbSorterBy.Shared
    },
    getSharedDate() {
      return rbSorterBy.SharedDate
    },
    getInactive() {
      return rbSorterBy.Inactive
    },
  },
  mounted() {
    if (this.isMobile) this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      const btn = this.$refs.btnSort
      const dropdown = this.$refs.dropdownMenu

      const withValue = btn.offsetWidth
      if (this.isMobile) {
        dropdown.style.width = withValue + 'px'
      }
    },
    sort(value) {
      this.$emit('sort', value)
    },
  },
}
</script>

<style lang="scss" scoped>
div.dropdown-menu.show {
  top: 5px !important;
  left: -2.8rem !important;
}

@media only screen and (max-width: 600px) {
  div.dropdown-menu.show {
    left: -2.1rem !important;
  }
}
</style>
